import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";

export const ButtonWithTippy = () => (
  <TippyV2
    content={t("spaces.bookmarks.add_link")}
    animation="fade"
    placement="bottom"
    className="flex size-5 items-center"
  >
    <Icon
      aria-label={t("spaces.bookmarks.add_link")}
      size={16}
      type="plus-v2"
    />
  </TippyV2>
);
